import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ITaskRestriction } from '../../medtracs-entities/data.queries/tasks/get.tasks.entity';

@Component({
   selector: 'app-restrictions-modal',
   templateUrl: './restrictions-modal.component.html',
   styleUrls: ['./restrictions-modal.component.css'],
})
export class RestrictionsModalComponent {
   @Input() restrictions: ITaskRestriction[] = [];

   @ViewChild('modalTemplate', { static: true }) modalTemplate!: TemplateRef<any>;

   bsModalRef?: BsModalRef;

   close(): void {
      this.bsModalRef?.hide();
   }
}
